import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";
import { Link } from "react-router-dom";

function Returns() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main
        id="main"
        className="main-content main-content--page main-content--page--margin"
      >
        <div className="shopify-section">
          <div className="page-title">
            <h1>RETURNS & EXCHANGES</h1>
          </div>
          <div className="policy-content">
            <p>
              We want you to be completely satisfied with your purchase. If for
              any reason you are not happy with your order, we offer a
              straightforward returns process.
            </p>

            <h2>RETURNS POLICY</h2>
            <p>
              You have 14 days from the date of receipt to return items for a
              refund or exchange. Items must be returned in their original
              condition, unworn, unwashed and with all tags attached.
            </p>
            <p>
              Please note that we cannot accept returns on the following items:
            </p>
            <ul>
              <li>Sale or discounted items</li>
              <li>Gift cards</li>
              <li>Personalised or made-to-order items</li>
              <li>Items marked as non-returnable at the time of purchase</li>
            </ul>

            <h2>HOW TO RETURN</h2>

            <h3>UK Returns</h3>
            <p>
              UK customers can return items free of charge using our prepaid
              returns label. To initiate a return:
            </p>
            <ol>
              <li>
                Complete the returns form included with your order, indicating
                which items you wish to return and the reason
              </li>
              <li>
                Pack the items securely in their original packaging where
                possible
              </li>
              <li>
                Attach the prepaid returns label provided with your order to the
                outside of the package
              </li>
              <li>
                Drop the package at your nearest post office or arrange a
                collection
              </li>
            </ol>

            <h3>EU Returns</h3>
            <p>
              EU customers should complete the returns form and send items back
              to our returns address:
            </p>
            <div className="info-box">
              <p>
                <strong>Margotal Returns Department</strong>
                <br />
                High Standing
                <br />
                Harding Road, Brinklow
                <br />
                Milton Keynes
                <br />
                United Kingdom
                <br />
                MK10 0DF
              </p>
            </div>
            <p>
              Please note that customers are responsible for return postage
              costs from the EU. We recommend using a tracked service as we
              cannot be held responsible for items lost in transit.
            </p>

            <h3>Rest of World Returns</h3>
            <p>
              International customers should complete the{" "}
              <Link onClick={toTop} to="/">
                Global-E Returns Form
              </Link>{" "}
              to initiate a return. Please note that customers are responsible
              for return postage costs. We recommend using a tracked service.
            </p>

            <h2>REFUNDS</h2>
            <p>
              Once we receive your return, we will inspect the items to ensure
              they meet our returns policy criteria. If approved, your refund
              will be processed within 7 working days.
            </p>
            <p>
              Refunds will be issued to the original payment method used for the
              purchase. Please allow 5-10 working days for the refund to appear
              in your account, depending on your card issuer.
            </p>
            <p>
              If you used a discount code on your order, this will not be
              refunded or reinstated. Original delivery charges are
              non-refundable unless the return is due to an error on our part.
            </p>

            <h2>EXCHANGES</h2>
            <p>
              We do not offer direct exchanges at this time. If you would like a
              different size or colour, please return the original item for a
              refund and place a new order for the item you require.
            </p>
            <p>
              This ensures you receive your replacement as quickly as possible.
            </p>

            <h2>FAULTY OR INCORRECT ITEMS</h2>
            <p>
              We quality check all items before dispatch, but in the rare event
              that you receive a faulty or incorrect item, please contact our
              customer service team immediately.
            </p>
            <p>
              We will arrange for the item to be collected free of charge and
              will issue a full refund or replacement once we receive the item
              back.
            </p>

            <h2>RETURNS TIMEFRAME</h2>
            <p>
              You have 14 days from the date of receipt to return items. Items
              must be returned within 28 days of the receipt date. Returns
              received after 28 days may not be accepted.
            </p>

            <div className="info-box">
              <p>
                <strong>Important:</strong> We strongly recommend using a
                tracked postal service for all returns. Margotal cannot be held
                responsible for items lost or damaged in transit.
              </p>
            </div>

            <h2>CONTACT US</h2>
            <p>
              If you have any questions about returns or need assistance, please
              contact our customer service team at{" "}
              <Link onClick={toTop} to="/contact">
                upper@margotal.art
              </Link>
            </p>
            <p>
              Our customer service team is available Monday to Friday, 10:00 -
              18:00 (GMT), excluding UK public holidays.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </body>
  );
}

export default Returns;
